export default {
    date: 'Дата',
};
